import { render, staticRenderFns } from "./delDialogVisible.vue?vue&type=template&id=2584af60&scoped=true&"
import script from "./delDialogVisible.vue?vue&type=script&lang=js&"
export * from "./delDialogVisible.vue?vue&type=script&lang=js&"
import style0 from "./delDialogVisible.vue?vue&type=style&index=0&id=2584af60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584af60",
  null
  
)

export default component.exports